import md5 from 'blueimp-md5/js/md5'
import decryptToken from './decryptToken'

const trackingEvents = () => {

  window.dataLayer = window.dataLayer || []

  let success = (token, subscription_identifier) => {
    const user_id = decryptToken(token).user_id
    window.dataLayer.push({
      'event': 'trigger',
      'eventCategory': 'Single Opt In',
      'eventAction': subscription_identifier,
      'eventLabel': md5(user_id)
    })
  }

  let notValidEmail = () => {
    window.dataLayer.push({
      'event': 'trigger',
      'eventCategory': 'Formular',
      'eventAction': 'SOI Fehler',
      'eventLabel': 'Email nicht gültig'
    })
  }

  let unconfirmed = () => {
    window.dataLayer.push({
      'event': 'trigger',
      'eventCategory': 'Formular',
      'eventAction': 'SOI Fehler',
      'eventLabel': 'DOI fehlt'
    })
  }

  let confirmed = () => {
    window.dataLayer.push({
      'event': 'trigger',
      'eventCategory': 'Formular',
      'eventAction': 'SOI Fehler',
      'eventLabel': 'Multi signup'
    })
  }

  let overlayShown = () => {
    window.dataLayer.push({
      'event': 'trigger-no',
      'eventCategory': 'Intern',
      'eventAction': 'View',
      'eventLabel': 'NL-Overlay'
    })
  }

  return {
    success,
    notValidEmail,
    unconfirmed,
    confirmed,
    overlayShown
  };
}

export default trackingEvents
